module.exports = __webpack_public_path__ + "static/media/p.a3ebcaf6.jpg";